import { render, staticRenderFns } from "./report-leavewords.vue?vue&type=template&id=585cac55&"
import script from "./report-leavewords.vue?vue&type=script&lang=js&"
export * from "./report-leavewords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports